import { Container, Row, Col } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";
import projImg5 from "../assets/img/project-img5.png";
import projImg6 from "../assets/img/project-img6.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const projects = [
    {
      title: "HTML & CSS Website",
      description: "Responsive website built with clean layout",
      imgUrl: projImg1,
      link: "https://diaa-codes.github.io/Easyfly-Booking/",
    },
    {
      title: "HTML5 & CSS3 Website",
      description: "Modern design using semantic HTML and CSS3",
      imgUrl: projImg2,
      link: "https://diaa-codes.github.io/Sotra-E-Commerce/",
    },
    {
      title: "Bootstrap Website",
      description: "Fully responsive layout using Bootstrap",
      imgUrl: projImg3,
      link: "https://diaa-codes.github.io/PizzaCiao-Resturant/",
    },
    {
      title: "Fresh Cart",
      description: "Interactive cart using JavaScript",
      imgUrl: projImg4,
      link: "https://diaa-codes.github.io/Fresh-Cart/",
    },
    {
      title: "UI/UX Web Design",
      description: "User-centered website design in Figma",
      imgUrl: projImg5,
      link: "https://www.behance.net/gallery/242268895/UIUX-Web-Design-Shoezna-E-Commerce",
    },
    {
      title: "UI/UX Mobile App",
      description: "Mobile app UI/UX design",
      imgUrl: projImg6,
      link: "https://www.behance.net/gallery/243710867/_",
    },
  ];
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    A selection of front-end and UI/UX projects showcasing
                    responsive design, clean code, and user-focused experiences.
                  </p>

                  <Row>
                    {projects.map((project, index) => (
                      <ProjectCard key={index} {...project} />
                    ))}
                  </Row>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>

      <img
        className="background-image-right"
        src={colorSharp2}
        alt="background"
      />
    </section>
  );
};
